import { Empty } from "antd";
import { ReactNode } from "react";
import { Post } from "store/posts/postConstants";
import PostCard from "../../PostCard/PostCard";

const PostCardGrid = <T extends Post = Post>({
  postList,
  children,
}: {
  postList: T[];
  className?: string;
  children?: (...args: Parameters<Parameters<Array<T>["map"]>[0]>) => ReactNode;
}) => {
  return postList.length ? (
    <div className="flex flex-wrap justify-center gap-x-6 gap-y-8 p-8">
      {postList.map((post, ...args) => (
        <div key={post.id} className="w-[320px]">
          {children ? children(post, ...args) : <PostCard post={post} />}
        </div>
      ))}
    </div>
  ) : (
    <Empty className="my-auto" description="Nothing to show" />
  );
};

export default PostCardGrid;
